import { Column, ColumnTypes } from 'ui/components/Table/ItemsTable';

export const receiveWizardColumns: Column[] = [
  {
    title: 'Items',
    type: ColumnTypes.renderByCustomRow,
  },
  {
    title: '',
    type: ColumnTypes.renderByCustomRow,
  },
  {
    title: 'Quantity',
    type: ColumnTypes.renderByCustomRow,
    align: 'right',
  },
];

export const RECEIVE_ITEM_TABLE_HEIGHT = 500;

export const receiveWizardSummaryColumns: Column[] = [
  {
    title: 'Item',
    type: ColumnTypes.renderByCustomRow,
  },
  {
    title: 'Qty at Location',
    type: ColumnTypes.renderByCustomRow,
  },
  {
    title: 'Qty to Receive',
    type: ColumnTypes.renderByCustomRow,
  },
];

export const splitColumns: Column[] = [
  {
    title: 'Item',
    type: ColumnTypes.renderByCustomRow,
  },

  {
    title: 'Quantity Remaining',
    type: ColumnTypes.renderByCustomRow,
  },
];
